import TextStyle from '@tiptap/extension-text-style'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    fontSize: {
      setFontSize: (size: string) => ReturnType
      unsetFontSize: () => ReturnType
    }
    letterSpacing: {
      setLetterSpacing: (size: string) => ReturnType
      unsetLetterSpacing: () => ReturnType
    }
    lineHeight: {
      setLineHeight: (size: string) => ReturnType
      unsetLineHeight: () => ReturnType
    }
    textTransform: {
      setTextTransform: (size: string) => ReturnType
      unsetTextTransform: () => ReturnType
    }
  }
}

export const TextStyleExtended = TextStyle.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      fontSize: {
        default: null,
        parseHTML: (element) => element.style.fontSize.replace('px', ''),
        renderHTML: (attributes) => {
          if (!attributes.fontSize) {
            return {}
          }

          return {
            style: `font-size: ${attributes.fontSize}px`,
          }
        },
      },
      letterSpacing: {
        default: null,
        parseHTML: (element) => element.style.letterSpacing,
        renderHTML: (attributes) => {
          if (!attributes.letterSpacing) {
            return {}
          }

          return {
            style: `letter-spacing: ${attributes.letterSpacing}`,
          }
        },
      },
      lineHeight: {
        default: null,
        parseHTML: (element) => {
          return element.style.lineHeight
        },
        renderHTML: (attributes) => {
          if (!attributes.lineHeight) {
            return {}
          }

          return {
            style: `display: inline-block; line-height: ${attributes.lineHeight};`,
          }
        },
      },
      textTransform: {
        default: null,
        parseHTML: (element) => element.style.textTransform,
        renderHTML: (attributes) => {
          if (!attributes.textTransform) {
            return {}
          }

          return {
            style: `text-transform: ${attributes.textTransform}`,
          }
        },
      },
    }
  },

  addCommands() {
    return {
      ...this.parent?.(),
      setFontSize:
        (fontSize) =>
        ({ commands }) =>
          commands.setMark(this.name, { fontSize }),
      unsetFontSize:
        () =>
        ({ chain }) =>
          chain().setMark(this.name, { fontSize: null }).removeEmptyTextStyle().run(),
      setLetterSpacing:
        (letterSpacing) =>
        ({ commands }) =>
          commands.setMark(this.name, { letterSpacing }),
      unsetLetterSpacing:
        () =>
        ({ chain }) =>
          chain().setMark(this.name, { letterSpacing: null }).removeEmptyTextStyle().run(),
      setLineHeight:
        (lineHeight) =>
        ({ commands }) =>
          commands.setMark(this.name, { lineHeight }),
      unsetLineHeight:
        () =>
        ({ chain }) =>
          chain().setMark(this.name, { lineHeight: null }).removeEmptyTextStyle().run(),
      setTextTransform:
        (textTransform) =>
        ({ commands }) =>
          commands.setMark(this.name, { textTransform }),
      unsetTextTransform:
        () =>
        ({ chain }) =>
          chain().setMark(this.name, { textTransform: null }).removeEmptyTextStyle().run(),
    }
  },
})

export default TextStyleExtended
